import type { RegUIClient, RegUISessionDetails } from "@foundation/reg-ui-client";

import { SignInButtons } from "./types";
import { DEFAULT_CONTEXT_PROPS } from "./NavContext";

export default class NavSignInClient {
    regUIClient: RegUIClient | null;
    desktopSignInButton?: Element;
    mobileSignInButton?: Element;
    subscriptionUrl?: string;
    upgradeUrl?: string;

    constructor() {
        this.regUIClient = null;
    }

    setSubscriptionUrl(subscriptionUrl: string) {
        this.subscriptionUrl = subscriptionUrl;
    }

    getSubscriptionUrl() {
        return this.subscriptionUrl || DEFAULT_CONTEXT_PROPS.subscriptionUrl;
    }

    getUpgradeUrl() {
        return this.upgradeUrl || DEFAULT_CONTEXT_PROPS.upgradeUrl;
    }

    getDesktopSignInButton() {
        return this.desktopSignInButton;
    }

    getMobileSignInButton() {
        return this.mobileSignInButton;
    }

    setSignInButton = (signInButtons: SignInButtons) => {
        const { mobileSignInButton, desktopSignInButton } = signInButtons;

        if (mobileSignInButton) {
            this.mobileSignInButton = mobileSignInButton;
        }
        if (desktopSignInButton) {
            this.desktopSignInButton = desktopSignInButton;
        }
        const regUIClient = this.getRegUIClient();

        if (regUIClient) {
            if (this.mobileSignInButton) regUIClient.addTextElements(this.mobileSignInButton);
            if (this.desktopSignInButton) regUIClient.addTextElements(this.desktopSignInButton);
        }
    };

    getRegUIClient(): RegUIClient | null {
        return this.regUIClient;
    }

    setRegUIClient = (client: RegUIClient) => {
        this.regUIClient = client;
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setOnUserInfoReady = (client: RegUIClient, _sessionDetails: RegUISessionDetails) => {
        if (this.getRegUIClient()) {
            // already initialized

            return;
        }

        const desktopSignInButton = this.getDesktopSignInButton();
        const mobileSignInButton = this.getMobileSignInButton();

        if (desktopSignInButton) client.addTextElements(desktopSignInButton);
        if (mobileSignInButton) client.addTextElements(mobileSignInButton);

        this.setRegUIClient(client);
    };

    onSignOut = async () => {
        const client = this.getRegUIClient();

        try {
            const success = await client?.logoutUser();

            if (success) {
                window.location.reload();
            } else {
                console.error("Logging user out failed");
            }
        } catch (error) {
            console.error(error);
        }
    };
}
